import { Box, Button, Chip, Tooltip, useMediaQuery, useTheme } from "@mui/material";
import { Cancel } from "@mui/icons-material";
import {
  selectedBrandChip,
  selectedBrandsContainer
} from "../../../pages/Dashboard/components/FilteringPaginationSx";
import theme from "../../../theme";

const HorizontalChipsWithTooltip = ({
  arr,
  setSelectedArr
}) => {

  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));

  return (
    arr?.length > 0 ? (
      <Box sx={{
        display: "flex",
        alignItems: "center",
        gap: "0.25rem"
      }}>
        {arr.map((item, itemIdx) => {
          if (itemIdx <= 3) {
            return (
              <Chip
                key={item?.value}
                label={item?.label}
                variant="outlined"
                onDelete={() => {
                  setSelectedArr(arr => {
                    return arr?.filter?.(currItem => currItem?.value !== item?.value);
                  })
                }}
                sx={selectedBrandChip}
                deleteIcon={<Cancel />}
                size={isMobile ? "small" : "medium"}
              />
            );
          } else if (itemIdx === 4) {
            return (
              <Tooltip
                slotProps={{
                  tooltip: {
                    sx: {
                      border: `1px solid ${theme.palette.primary.main}`,
                      backgroundColor: `${theme.palette.background.paper} !important`,
                    },
                  },
                }}
                title={
                  <Box sx={{
                      ...selectedBrandsContainer,
                      maxWidth: "400px",
                      display: "flex",
                      flexWrap: "wrap",
                      padding: "0.5rem",
                      margin: "0",
                      backgroundColor: theme.palette.background.paper
                    }}
                  >
                    {arr.map((item) => (
                      <Chip
                        key={item?.value}
                        label={item?.label}
                        variant="outlined"
                        size={isMobile ? "small" : "medium"}
                        onDelete={() => {
                          setSelectedArr((arr) => {
                            return arr?.filter?.(
                              (currItem) => item?.value !== currItem?.value,
                            );
                          });
                        }}
                        sx={selectedBrandChip}
                        deleteIcon={<Cancel />}
                      />
                    ))}
                  </Box>
                }
              >
                <Button
                  sx={{
                    textDecoration: "underline"
                  }}
                >+{arr.length - 4} more</Button>
              </Tooltip>
            );
          } else {
            return null;
          }
        })}
      </Box>
    ) : null
  );
};

export default HorizontalChipsWithTooltip;